export default __webpack_public_path__ + "static/media/eleImg_pwd_2_2.da4ed25d.png";